import AccessDenied from "./patterns/AccessDenied";
import Incomplete from "./patterns/Incomplete";

export default {
  AccessDenied,
  Incomplete
};
